import PropTypes from 'prop-types';
import Popover from 'sd-ui/dist/commonjs/components/Popover/Popover';
import ExtrasButtonContainer from '../enhancementButtons/extrasButton/extrasButtonContainer';
import ExtraPropTypes from './extraPropType';
import ExtrasPopoverContents from './popoverContents/extrasPopoverContents';

export default function ExtrasPopover({ extras, pii, adobeContentType }) {
  if (extras.length === 0) {
    return null;
  }

  return (
    <Popover
      id="extras"
      className="extras-popover"
      renderButton={props => <ExtrasButtonContainer {...props} />}
      renderChildren={closePopover => (
        <ExtrasPopoverContents
          closePopover={closePopover}
          extras={extras}
          pii={pii}
          adobeContentType={adobeContentType}
        />
      )}
    />
  );
}

ExtrasPopover.propTypes = {
  extras: PropTypes.arrayOf(PropTypes.shape(ExtraPropTypes)).isRequired,
  pii: PropTypes.string.isRequired,
  adobeContentType: PropTypes.string,
};

ExtrasPopover.defaultProps = {
  adobeContentType: undefined,
};
